// src/views/Admin/AllProposals.jsx
import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import './AllInvoices.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';

const AllProposals = () => {
  const [allProposals, setAllProposals] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProposals = async () => {
      const proposalsSnap = await getDocs(
        query(collection(db, 'proposalTokens'), orderBy('createdAt', 'desc'))
      );

      const proposalsList = proposalsSnap.docs.map(docSnap => {
        const data = docSnap.data();
        return {
          id: docSnap.id,
          clientName: data.clientInfo?.businessName || data.clientInfo?.name || '—',
          clientEmail: data.clientInfo?.email || '—',
          createdAt: data.createdAt?.toDate?.(),
          ...data,
        };
      });

      setAllProposals(proposalsList);
    };

    fetchProposals();
  }, []);

  const filtered = allProposals.filter(p => {
    const date = p.createdAt?.toDate?.() || p.createdAt || null;
    if (!date) return false;
    if (fromDate && date < fromDate) return false;
    if (toDate && date > toDate) return false;
    return true;
  });

  const handleOpenProposal = (proposal) => {
    setSelectedProposal(proposal);
    setShowModal(true);
  };

  const handleGoToClient = (proposal) => {
    if (!proposal?.clientEmail) return;
    const emailId = encodeURIComponent(proposal.clientEmail.toLowerCase());
    navigate(`/admin/clients/${emailId}/proposal`);
  };

  return (
    <div className="all-invoices-container">
      <h2>Propuestas Globales</h2>

      <div className="filters">
        <label>Desde:
          <DatePicker
            selected={fromDate}
            onChange={setFromDate}
            dateFormat="dd/MM/yyyy"
            placeholderText="Selecciona desde"
            className="date-picker"
          />
        </label>
        <label>Hasta:
          <DatePicker
            selected={toDate}
            onChange={setToDate}
            dateFormat="dd/MM/yyyy"
            placeholderText="Selecciona hasta"
            className="date-picker"
          />
        </label>
      </div>

      <div className="table-wrapper">
        <table className="invoices-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>Email</th>
              <th>Total</th>
              <th>Depósito</th>
              <th>Saldo</th>
              <th>Servicios</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => {
              const total = parseFloat(p.total || 0);
              const deposit = parseFloat(p.deposit || 0);
              const remaining = parseFloat(p.remaining ?? total - deposit);

              return (
                <tr
                  key={p.id}
                  className="clickable-row"
                  onClick={() => handleOpenProposal(p)}
                >
                  <td>{(p.createdAt?.toDate?.() || p.createdAt)?.toLocaleDateString?.() || '—'}</td>
                  <td>{p.clientName}</td>
                  <td>{p.clientEmail}</td>
                  <td>${total.toFixed(2)}</td>
                  <td>${deposit.toFixed(2)}</td>
                  <td>${remaining.toFixed(2)}</td>
                  <td>{p.items?.length || 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showModal && selectedProposal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-3xl">
            <div className="modal-header">
              <h3>Detalle de Propuesta</h3>
              <button onClick={() => setShowModal(false)}>✕</button>
            </div>

            <div className="modal-body space-y-3">
              <p><strong>Cliente:</strong> {selectedProposal.clientName}</p>
              <p><strong>Email:</strong> {selectedProposal.clientEmail}</p>
              <p><strong>Fecha:</strong> {selectedProposal.createdAt?.toLocaleDateString?.('es-PR') || '—'}</p>
              <p><strong>Total:</strong> ${parseFloat(selectedProposal.total || 0).toFixed(2)}</p>
              <p><strong>Depósito:</strong> ${parseFloat(selectedProposal.deposit || 0).toFixed(2)}</p>
              <p><strong>Saldo:</strong> ${parseFloat(selectedProposal.remaining ?? (selectedProposal.total || 0) - (selectedProposal.deposit || 0)).toFixed(2)}</p>
              <p><strong>Estado:</strong> {selectedProposal.status || 'pendiente'}</p>

              <div>
                <h4 className="font-semibold mt-4 mb-2">Servicios</h4>
                <ul className="proposal-items">
                  {(selectedProposal.items || []).map((item, idx) => (
                    <li key={idx}>
                      <p><strong>{item.name || `Servicio ${idx + 1}`}</strong></p>
                      <p className="text-sm text-gray-600">{item.description || '—'}</p>
                      <p className="text-sm">${parseFloat(item.price || 0).toFixed(2)} x {item.quantity || 1}</p>
                    </li>
                  ))}
                  {(!selectedProposal.items || selectedProposal.items.length === 0) && (
                    <li className="text-sm text-gray-500">Sin servicios registrados.</li>
                  )}
                </ul>
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={() => handleGoToClient(selectedProposal)} className="btn-primary">
                Ir al cliente
              </button>
              <button onClick={() => setShowModal(false)} className="btn-secondary">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllProposals;
